enum AmlSubstatusType {
  UNTRIGGERED = 1,
  PENDING_CUSTOMER = 2,
  ANSWERED = 3,
  REVIEWED = 4,
}

export default AmlSubstatusType
